// „Gesehen“ ohne Lücke (E3, S4) – reine Logik, ohne React. Wer „gesehen“
// drückt, sagt dem Server, bis wann er Änderungen gezeigt bekommen hat
// (`gezeigtBis`, Kern: gesehenEingabe). Kam am Server inzwischen noch etwas
// dazu, antwortet er 409 „konflikt“, schreibt nichts, und die Seite lädt neu
// – vorher galt „gesehen“ bis zur Uhrzeit des Klicks, und eine Änderung
// zwischen Laden und Klick wäre ungesehen mit abgehakt worden (DECISIONS.md,
// 21.10., „E3, Schritt 1 gebaut“, Punkt 22).
//
// Der Zeitpunkt ist immer einer, den der Server geliefert hat – nie die Uhr
// dieses Laptops (die kann gehen, wie sie will):
//  - das Büro (Freigabe-Seite, „bitte ansehen“): der jüngste gesendete
//    Nachtrag oder die zuletzt geänderte Dachplanung – dieselbe Regel wie am
//    Server (server/src/crm/lesen.ts, letzteAenderungVonDraussen).
//    Bis E3c drückte auch das Lager „gesehen“ – an seiner Materialliste.

import type { CrmAufnahme } from "@happy-energy/kern";

type VonDraussen = Pick<CrmAufnahme, "nachtraege"> & { anlage: Pick<CrmAufnahme["anlage"], "k2GeaendertAm"> };

/**
 * Die jüngste Änderung von draußen, die diese Besichtigung zeigt: der
 * jüngste gesendete Nachtrag oder die zuletzt geänderte Dachplanung, das
 * Jüngere – genau der Text, den der Server geschickt hat. Null: keins von
 * beiden (dann gibt es auch nichts „anzusehen“).
 */
export function juengsteVonDraussen(a: VonDraussen): string | null {
  let juengste: string | null = null;
  for (const zeit of [...a.nachtraege.map((n) => n.gesendetAm), a.anlage.k2GeaendertAm]) {
    if (zeit === null || Number.isNaN(Date.parse(zeit))) continue;
    if (juengste === null || Date.parse(zeit) > Date.parse(juengste)) juengste = zeit;
  }
  return juengste;
}
